var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"input-default data-hj-allow",class:_vm.inputClass,attrs:{"type":"text","name":_vm.id,"id":_vm.id,"placeholder":_vm.placeholder,"autocomplete":"off"},on:{"input":_vm.inputTyping}})
}
var staticRenderFns = []

export { render, staticRenderFns }